import { Component, OnInit } from '@angular/core';
import mockedAixmCatalogue from './mocked-aixm-catalogue.json';

interface IFeatureOption {
  label: string;
  value: string;
}

@Component({
  selector: 'data-catalogue',
  templateUrl: './data-catalogue.component.html',
  styleUrls: ['./data-catalogue.component.css']
})
export class DataCatalogueComponent implements OnInit {

    features: IFeatureOption[] = [];
    searchText: string = '';

    filteredFeatures(): IFeatureOption[] {
        const search = this.searchText.toLowerCase();
        return this.features.filter(f => f?.label?.toLowerCase().includes(search));
    }

    mapFeatures(): void {
        const array: IFeatureOption[] = [];

        mockedAixmCatalogue?.schema?.element?.forEach((el: any) => {
          array.push({
              label: el?._name,
              value: el?._type
          })
        })

        this.features = array;
    }

    ngOnInit() {
        this.mapFeatures();
    }
}